import React from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

/**
 * @param {string} value - current notes text
 * @param {Function} onChange - (value) => void
 * @param {string} label - section title, defaults to "Notes"
 * @param {boolean} optional - shows "(Optional)" next to label when true
 * @param {boolean} mandatory - shows "(mandatory)" next to label when true
 * @param {string} placeholder
 * @param {number} rows
 * @param {boolean} disabled
 * @param {string} className
 */
const Notes = ({
  value,
  onChange,
  label,
  optional,
  mandatory,
  placeholder,
  rows,
  disabled,
  className,
}) => {
  return (
    <div className={`notes-section ${className || ""}`}>
      <div className="notes-section-title">
        {label}
        {optional && !mandatory && (
          <span className="notes-optional-label"> (optional)</span>
        )}
        {mandatory && (
          <span className="notes-optional-label"> (mandatory)</span>
        )}
      </div>
      <Form.Control
        as="textarea"
        rows={rows}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className="notes-textarea"
      />
    </div>
  );
};

Notes.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  optional: PropTypes.bool,
  mandatory: PropTypes.bool,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

Notes.defaultProps = {
  value: "",
  label: "Notes",
  optional: true,
  mandatory: false,
  placeholder: "Type any notes here...",
  rows: 4,
  disabled: false,
  className: "",
};

export default Notes;